import { render, staticRenderFns } from "./recruitHome.vue?vue&type=template&id=fb041e2e&scoped=true&"
import script from "./recruitHome.vue?vue&type=script&lang=js&"
export * from "./recruitHome.vue?vue&type=script&lang=js&"
import style0 from "./recruitHome.vue?vue&type=style&index=0&id=fb041e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb041e2e",
  null
  
)

export default component.exports